import React from "react";
import { useTranslation } from "react-i18next";
import { AutoCenter } from "antd-mobile";

import { CustomCollapse } from "../../../../components";

function CommonIssues({ data }) {
  const { t } = useTranslation();
  return (
    <div>
      {data ? (
        <CustomCollapse items={data} />
      ) : (
        <AutoCenter>{t("normal.nodata")}</AutoCenter>
      )}
    </div>
  );
}

export default CommonIssues;
